import { createSelector } from 'reselect';

export const getAllThreads = (state) => state.messages.threads;
export const getUnreadThreads = (state) => state.messages.unreadThreadsCount;
export const getIsLoadingThreads = (state) => state.messages.isLoadingThreads;

export const getFetchedAttachment = (state, { key }) => {
    const [threadId, fileId] = key.split('_');
    return state.messages.fetchedAttachments[threadId] ? state.messages.fetchedAttachments[threadId][fileId] : null;
};
export const getAllThreadsSortedByMessageDate = createSelector(
    [getAllThreads],
    (threads) => threads.sort((a, b) => new Date(b.lastMessageCreateDate) - new Date(a.lastMessageCreateDate))
);
export const getNewestThreadId = createSelector([getAllThreadsSortedByMessageDate],
    (threads) => (threads[0] ? threads[0].threadId : null));

export const getThreadById = (state, { threadId }) => state.messages.threads.find((t) => t.threadId === parseInt(threadId));

export const getMessagesFromThread = (state, { threadId }) => (state.messages.conversations[threadId] ? state.messages.conversations[threadId].messages : []);

export const getDates = (state, { threadId }) => (state.messages.conversations[threadId] ? state.messages.conversations[threadId].datesOrder : []);

export const getMessagesByDate = (state, { date, threadId }) => state.messages.conversations[threadId].days[date];

export const getMessageEdited = (state, { threadId }) => ((state.messages.conversations[threadId]) ? state.messages.conversations[threadId].draft : { body: '', attachments: [] });

export const getLatestMessageDate = createSelector(
    [getMessagesFromThread],
    (messages) => new Date(Math.max.apply(
        null,
        messages.map((message) => new Date(message.createDate))
    ))
);

export const getSendStatus = (state, { threadId }) => (state.messages.conversations[threadId] ? state.messages.conversations[threadId].isSending : false);
